import { BuilderConfig } from '../../types/Builder';

import BusinessHubInActionCarousel, { InActionCarouselProps } from './business-hub-In-action-carousel';

export const BusinessHubInActionCarouselBuilderConfig = {
    name: 'Business Hub In Action Carousel',
    inputs: [
        {
            name: 'title',
            type: 'string',
        },
        {
            name: 'items',
            type: 'list',
            subFields: [
                {
                    name: 'image',
                    type: 'file',
                    helperText: 'Use for mobile'
                },
                {
                    name: 'banner',
                    type: 'file',
                    helperText: 'Use for desktop'
                },
                {
                    name: 'subTitle',
                    type: 'string',
                },
                {
                    name: 'title',
                    type: 'string',
                },
                {
                    name: 'description',
                    type: 'string',
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<InActionCarouselProps> = {
    component: BusinessHubInActionCarousel,
    config: BusinessHubInActionCarouselBuilderConfig,
};

export default builderConfig;
